import { Injectable } from '@angular/core';
import { environment } from '@dxp/core/environment';
import {
    IAgentState,
    IQueueInformation,
    IWorkItemWithConversation,
} from '@dxp/core/models';
import { Subject } from 'rxjs';
import { SignalRHubService } from '../signalr.hub.service';

@Injectable({
    providedIn: 'root',
})
export class LiveHubService extends SignalRHubService {
    readonly #agentStatesSubject = new Subject<IAgentState[]>();
    readonly #queueInformationSubject = new Subject<IQueueInformation>();
    readonly #workItemsWithConversationsSubject = new Subject<
        IWorkItemWithConversation[]
    >();

    agents$ = this.#agentStatesSubject.asObservable();
    queueInformation$ = this.#queueInformationSubject.asObservable();
    workItemsWithConversations$ =
        this.#workItemsWithConversationsSubject.asObservable();

    name = 'Live';
    url = `${environment.liveUrl}/hub`;

    protected override registerHandlers() {
        this.hubConnection.on(
            'ReceiveQueueData',
            (queueInformation: IQueueInformation) => {
                this.messageReceived();

                this.logger.verbose(
                    'Live Hub Service (ReceiveQueueData) ->',
                    queueInformation,
                );
                this.logger.table(queueInformation);

                this.#queueInformationSubject.next(queueInformation);
            },
        );

        this.hubConnection.on(
            'ReceiveTenantAgentStates',
            (tenantAgentStates: IAgentState[]) => {
                this.messageReceived();

                this.logger.verbose(
                    'Live Hub Service (ReceiveTenantAgentStates) ->',
                    tenantAgentStates,
                );
                this.logger.table(tenantAgentStates);

                this.#agentStatesSubject.next(tenantAgentStates);
            },
        );

        this.hubConnection.on(
            'ReceiveWorkItemsWithConversations',
            (workItemsWithConversations: IWorkItemWithConversation[]) => {
                this.messageReceived();

                this.logger.verbose(
                    'Live Hub Service (ReceiveWorkItemsWithConversations) ->',
                    workItemsWithConversations,
                );
                this.logger.verbose(workItemsWithConversations);

                this.#workItemsWithConversationsSubject.next(
                    workItemsWithConversations,
                );
            },
        );
    }

    protected override unregisterHandlers() {
        this.hubConnection.off('ReceiveQueueData');
        this.hubConnection.off('ReceiveTenantAgentStates');
        this.hubConnection.off('ReceiveWorkItemsWithConversations');
    }
}
